export default __webpack_public_path__ + "static/sirio-6-e5a30edaf8dca40be01b49afcd58a146.jpg";